import { parseISO } from "date-fns";
import { array, date, number, object, string } from "yup";
import { resolveNumber } from "duck";
import { Fragments, WeightMeasureEnum } from "requests";
import { KG_TO_LBS } from "../../../../../duck";
import { FormValues } from "./types";

export const getDisplayedWeight = (
  measure: WeightMeasureEnum,
  weight: number | null
) => {
  if (weight != null && measure === WeightMeasureEnum.Lbs) {
    return +(weight * KG_TO_LBS).toFixed(2);
  }

  if (weight != null && measure === WeightMeasureEnum.G) {
    return +(weight * 1000).toFixed(3);
  }

  return weight;
};

export const getPatientInfo = (
  fullInfo: Fragments.StoredPatientInfo
): FormValues => ({
  name: fullInfo?.name || "",
  species: fullInfo?.species || null,
  breed: fullInfo?.breed || null,
  dateOfBirth: fullInfo?.dateOfBirth ? parseISO(fullInfo.dateOfBirth) : null,
  sex: fullInfo?.sex || null,
  weight: getDisplayedWeight(fullInfo.weightMeasure, fullInfo.weight || null),
  weightMeasure: fullInfo?.weightMeasure,
  procedureDate: fullInfo?.procedureDate
    ? parseISO(fullInfo?.procedureDate)
    : null,
  alerts: fullInfo?.alerts || "",
  procedures: fullInfo?.procedures || []
});

export const getValidationSchema = () =>
  object({
    name: string().required("Patient Name can't be empty."),
    species: string()
      .nullable()
      .required(),
    breed: string().nullable(),
    dateOfBirth: date().nullable(),
    sex: string().nullable(),
    weight: number()
      .transform(value => (Number.isNaN(value) ? -1 : value))
      .required()
      .positive()
      .nullable(),
    weightMeasure: string().required(),
    procedureDate: date().nullable(),
    alerts: string(),
    procedures: array()
  });

export const calculateWeight = (
  measure: WeightMeasureEnum,
  weight?: string | number | null
) => {
  if (weight != null && measure === WeightMeasureEnum.Lbs) {
    return +(+weight / KG_TO_LBS).toFixed(3);
  }

  if (weight != null && measure === WeightMeasureEnum.G) {
    return +(+weight / 1000).toFixed(3);
  }

  return resolveNumber(weight);
};
